<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("issue.edit_title") }}({{ this.$store.store.state.title }})</h1>
    <form>
      <b-card :title="this.$i18n.t('issue.delete_serial_search')" class="w-75 mb-3">
        <b-form-group
          id="select_date"
          label-cols-sm="4"
          label-cols-lg="2"
          :label="this.$i18n.t('issue.delete_serial')"
          label-for="input-horizontal"
        >
          <div class="d-flex align-items-center">
            <div class="flex-fill">
              <b-form-input v-model="qtyFrom" :placeholder="this.$i18n.t('issue.start_serial')" maxlength="25"></b-form-input>
            </div>
            <div class="flex-shrink-1 px-2" align="center">-</div>
            <div class="flex-fill">
              <b-form-input v-model="qtyTo" :placeholder="this.$i18n.t('issue.end_serial')" maxlength="25"></b-form-input>
            </div>
          </div>
        </b-form-group>
        <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("issue.search") }}</b-button>
      </b-card>
    </form>
    <div v-if="isSearch">
      <b-card :title="this.$i18n.t('issue.delete') + '(' + this.$i18n.t('issue.serial_qty') + '：' + this.serialCnt +')'" class="w-50">
        <b-table
          :striped="striped"
          :bordered="bordered"
          :borderless="borderless"
          :outlined="outlined"
          :small="small"
          :hover="hover"
          :dark="dark"
          :fixed="fixed"
          :foot-clone="footClone"
          :no-border-collapse="noCollapse"
          :items="items"
          :fields="fields"
          :head-variant="headVariant"
          :table-variant="tableVariant"
        >
          <template v-slot:cell(check)="row">
            <b-form-checkbox v-model="row.item.check">
            </b-form-checkbox>
          </template>
        </b-table>
        <b-button variant="danger" @click="del" class="float-right">{{ $i18n.t("issue.delete") }}</b-button>
      </b-card>
    </div>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      selected: null,
      qtyFrom: null,
      qtyTo: null,
      note: null,
      serialCnt: '',
      fields: [
        { key: 'check', label: this.$i18n.t('issue.delete') },
        { key: 'serial', label: this.$i18n.t('issue.serial') }
      ],
      items: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      errMsg: null,
      errSbj: null
    }
  },
  methods: {
    search: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {
        'mo': this.$store.store.state.editId,
        'start': this.qtyFrom,
        'end': this.qtyTo
      }

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/delete/serialList', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.isSearch = false
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var serialList = res.data.serial
            var items = []

            // 整形
            for (var i = 0; i < serialList.length; i++) {
              var serial = {}
              serial.check = false
              serial.serial = serialList[i]
              items.push(serial)
            }
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.serialCnt = serialList.length
            this.items.splice(0, 0, ...items)
            this.isSearch = true
          }
        })
        .catch(res => {
          this.isSearch = false
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    del: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      // チェック入りシリアルを取得
      var serialList = []
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].check) {
          serialList.push(this.items[i].serial)
        }
      }

      // 1つもチェックされていない場合はエラー
      if (serialList.length < 1) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('issue.check_hissu')
        this.$bvModal.show('md-err')
        return false
      }

      var body = {
        'serial': serialList,
        'mo': this.$store.store.state.editId
      }

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .delete(window.END_POINT + '/delete/serial',
          {
            'headers': headers,
            'data': body
          })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.errSbj = this.$i18n.t('common.button_modal_confirm')
            this.errMsg = this.$i18n.t('issue.delete_serial_complete')
            this.$bvModal.show('md-err')
            this.isSearch = false
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/IssueEdit.vue